const defaultState = {
  date: null,
}

export default function reducer(state=defaultState, action) {

    switch (action.type) {
      case "SET_WEEK_DATE": {
        return {
          ...state,
          date: action.payload
        }
      }
      default:{
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/weekReducer.js